const state = process.env.REACT_APP_STATE;
const server = process.env.REACT_APP_SERVER;
var backendUrl;

if (state === 'LOCAL') {
    backendUrl = 'http://localhost:5000';
}

if (state === 'PROD') {
    backendUrl = server;
}

module.exports = backendUrl;